import { apiService } from "../api"

export interface VerifyReminderResponse {
   /** Whether the "verify your email" reminder may be shown now. The once-per-24h
    *  cadence is enforced server-side by raauth's `verification_reminder` policy. */
   show: boolean
}

export const updateVerificationApi = {
   checkVerificationReminder: () => apiService.post<VerifyReminderResponse>("/api/users/verify-reminder", {}),
}
